// Detalles de reportes de incidentes

import React, { useEffect } from "react";
import {
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Typography,
  Box
} from "@mui/material";
import { getReportStatusLabel } from './ReportStatus';
import { formatMXDateTime } from '../util/DateUtil';
import { apiFetchJson } from '../fetchWrapper';

export default function ReportIncidentDetails({ incidentReport, onBack }) {
  const [site, setSite] = React.useState(null);
  const [employees, setEmployees] = React.useState([]);
  useEffect(() => {
    if (!incidentReport) return;
    apiFetchJson("/api/sites/" + incidentReport.siteId).then(setSite);
    apiFetchJson("/api/employees").then(setEmployees);
  }, []);

  if (!incidentReport) {
    return (
      <Box sx={{ maxWidth: 800, margin: "20px auto" }}>
        <Button
          sx={{ mb: 2, backgroundColor: "#3f74b1", color: "#fff", "&:hover": { backgroundColor: "#364f6b" } }}
          onClick={onBack}
          variant="contained"
        >
          Volver
        </Button>
        <Typography>No se ha seleccionado ningún informe de incidente.</Typography>
      </Box>
    );
  }

  const visibleEmployeeName = (id) => {
    const employee = employees.find((e) => e.id === id);
    if (employee) {
      return `${employee?.contactPerson?.lastnameFirst} ${employee?.contactPerson?.lastnameSecond}, ${employee?.contactPerson?.firstname}`;
    } else {
      return "Sin asignar";
    }
  };


  return (
    <Box sx={{ maxWidth: 800, margin: "20px auto" }}>
      <Button
        sx={{ mb: 2, backgroundColor: "#3f74b1", color: "#fff", "&:hover": { backgroundColor: "#364f6b" } }}
        onClick={onBack}
        variant="contained"
      >
        Volver
      </Button>

      <TableContainer sx={{ marginBottom: "20px" }}>
        <Table sx={{ '& .MuiTableCell-root': { borderBottom: '1px solid #eaeaea', py: 1.5 } }}>
          <TableBody>
            <TableRow>
              <TableCell><strong>ID</strong></TableCell>
              <TableCell>{incidentReport.id}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Latitude:</strong></TableCell>
              <TableCell>{incidentReport.latitude}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Longitude:</strong></TableCell>
              <TableCell>{incidentReport.longitude}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Ubicación:</strong></TableCell>
              <TableCell>{site?.name}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Autor:</strong></TableCell>
              <TableCell>{visibleEmployeeName(incidentReport.authorId)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Subjeto:</strong></TableCell>
              <TableCell>{incidentReport.subject}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Encargado:</strong></TableCell>
              <TableCell>{visibleEmployeeName(incidentReport.assignedToId)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Descripción:</strong></TableCell>
              <TableCell>{incidentReport.description}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Fecha de empiezo:</strong></TableCell>
              <TableCell>{getReportStatusLabel(incidentReport.reportStatus)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Fecha de fin de contrato:</strong></TableCell>
              <TableCell>{formatMXDateTime(incidentReport.createdAt)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Fecha de creación:</strong></TableCell>
              <TableCell>{formatMXDateTime(incidentReport.updatedAt)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
